import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaCheckCircle, FaShieldAlt, FaHandshake } from 'react-icons/fa';
import './FooterPages.css';

const ForInstitutions = () => {
    return (
        <div className="footer-page-container">
            <div className="footer-page-inner">
                <Link to="/" className="footer-back-btn">
                    <FaArrowLeft /> Back to Home
                </Link>

                <div className="footer-header">
                    <h1 className="footer-title">For Institutions</h1>
                    <p className="footer-subtitle">
                        Empower your academic curriculum with industry-leading expertise. Securely connect with vetted Professors of Practice.
                    </p>
                </div>

                <div className="footer-text-section">
                    <h2>Why Partner with EdVergenceX?</h2>
                    <div className="footer-grid-section" style={{ marginTop: '2rem', marginBottom: 0 }}>
                        <div className="footer-glass-card">
                            <div className="card-icon"><FaShieldAlt /></div>
                            <h3>NEP & UGC Compliant</h3>
                            <p>Our framework is fully aligned with the National Education Policy and UGC guidelines for engaging Professors of Practice.</p>
                        </div>
                        <div className="footer-glass-card">
                            <div className="card-icon"><FaCheckCircle /></div>
                            <h3>Vetted Experts</h3>
                            <p>Access a pool of professionals who have undergone rigorous background checks and peer reviews.</p>
                        </div>
                        <div className="footer-glass-card">
                            <div className="card-icon"><FaHandshake /></div>
                            <h3>Seamless Integration</h3>
                            <p>Easily integrate industry courses into your existing curriculum with our supportive tools and dashboard.</p>
                        </div>
                    </div>
                </div>

                <div className="footer-text-section">
                    <h2>How It Works for Universities</h2>
                    <ul className="footer-info-list" style={{ marginTop: '1.5rem' }}>
                        <li><strong>Register your Institution:</strong> Create a verified profile for your university or college.</li>
                        <li><strong>Post Requirements:</strong> List your needs for guest lectures, course modules, or mentorship.</li>
                        <li><strong>Match & Connect:</strong> Our AI matches you with the best industry talent suited for your needs.</li>
                        <li><strong>Collaborate Securely:</strong> Manage contracts, payments, and scheduling through our secure platform.</li>
                    </ul>
                    <div style={{ textAlign: 'center', marginTop: '3rem' }}>
                        <Link to="/register-university" className="footer-cta-btn">Join as an Institution</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForInstitutions;


